module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4wMZEDszqfGMFwAAAFNJREFUSMdj/L+U4T8DHQETA50BC4aIdiV1bbjajseH1LYMi5lMNLUMi9l0j8NRC0ctHLVw1MJRC0ctHLVwZFmI1rqiVcuNCV+TjhbNRMZh3/IGABrxD398kiO4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_desplazada.png
// module id = gXBe
// module chunks = 0